import { datadogLogs } from '@datadog/browser-logs';
import { useUpdateOrganizationMutation } from '@main/graphql/mutations/UpdateOrganization.admin.generated';
import { api as getOrganizationApi } from '@main/graphql/queries/GetOrganization.generated';
import { toError } from '@main/shared/utils';
import { errorToast, successToast } from '@main/ui';
import { useCallback } from 'react';

import { useBackofficeDispatch } from '../../hooks/redux-toolkit-hooks';

export function useUpdateOrganizationHandler(orgId?: string) {
  const dispatch = useBackofficeDispatch();

  return useCallback(
    async (resultPromise: ReturnType<ReturnType<typeof useUpdateOrganizationMutation>[0]>) => {
      try {
        await resultPromise.unwrap();

        if (orgId) {
          // A forced refetch joins pending reads, which may predate the save.
          await dispatch(
            getOrganizationApi.util.getRunningQueryThunk('GetOrganization', { orgId }),
          )?.unwrap();

          await dispatch(
            getOrganizationApi.endpoints.GetOrganization.initiate(
              { orgId },
              { subscribe: false, forceRefetch: true },
            ),
          ).unwrap();
        }

        successToast('Organization updated successfully');
      } catch (error) {
        errorToast('Organization update failed');
        datadogLogs.logger.error('Organization update failed', {}, toError(error));
      }
    },
    [dispatch, orgId],
  );
}
